<template>
  <section class="screen">

<div class="screen__meta meta-overlay spacer-bottom">
  <div class="screen__user">

    <div @click="$router.push('/user/' + activePatient.payload.uid)" v-if="activePatient.active" class="screen__user-image">
      <img src="/static/user.svg">
    </div>

    <span v-if="activePatient.active">{{activePatient.payload.displayName}}</span>
    <span v-else>Select Patient</span>
    <span class="number">707.123.1234</span>

    </div>

</div>
    <div class="screen__card" :class="{'active-card': card.type == 'SA'}">
      <div class="screen__meta meta-overlay">
        <span class="card-title">{{ card.type | cardType}}</span>
        <!-- {{card}} -->

        <!-- <span>Provider</span><br>
        <span>Dr. Timothy Wieg, DDS</span> -->
      </div>

      <div class="screen__meta">
        <div class="edit-container">
          <div class="screen__edit">+</div>
        </div>
        <!-- <p class="description">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Consequatur culpa cum provident, vero voluptatum deleniti ut, eaque consectetur sit?</p> -->
        <!-- <textarea class="description" v-model="description" placeholder="description"></textarea> -->
        <template v-if="card.description != null">
          <textarea class="description" v-model="description" placeholder="description"></textarea>
        </template>
        <template v-if="card.price != null && card.type === 'BP'">Balance Paid: ${{card.price}}</template>
        <template v-if="card.price != null && card.type === 'BR'">Amount due: ${{card.price}}</template>

      </div>
      <!-- <div class="screen__services">
        <div class="specific">
          Procedure Type
          <div class="service-tab">Tooth filling</div>
          <div class="service-tab">Bridge</div>
          <div class="service-tab">Implant</div>
          <div class="service-tab">Crowning</div>

        </div>
        <div class="general">
          Appointment Type
          <div class="service-tab">Preventive</div>
          <div class="service-tab">Cosmetic</div>
          <div class="service-tab">Restoritive</div>
          <div class="service-tab">Endodontic</div>
          <div class="service-tab">Orthodontic</div>
        </div>
      </div> -->

    </div>

    <div class="screen__actions">
      <template v-if="card.type == 'AR'">
        <span>Confirm Request</span>
        <span @click="updateAppointment(card)" class="submit">confirm apointment</span>
      </template>
      <template v-else-if="card.type == 'SA'">
        <!-- <span>Confirm Request</span> -->
        <span @click="cancel(card)" class="submit">cancel apointment</span>
      </template>

      <template v-else-if="card.type == 'BR'">
        <!-- <span>Confirm Request</span> -->
        <span @click="payBalance(card)" class="submit">Pay Balance</span>
      </template>
    </div>


    <div class="screen__actions">
      <div class="message"  @click="messageUser(card.description)">message user</div>
    </div>

<!-- <div v-for="(display, idx) in users" class="tab" :key="idx" @click="$router.push('/user/' + display.uid)">
        <div class="tab__type bg-12"></div>
        <h2 class="tab__name">{{ display.displayName}}</h2>
    </div> -->



  </section>

</template>
<script>
import { Carousel, Slide } from 'vue-carousel'
import { page } from 'vue-analytics'
import AOS from '../main'
import { firestore } from "../main"
import * as firebase from "firebase"
import { mapMutations, mapGetters } from 'vuex'
import { Kalendar } from 'kalendar-vue';
import 'kalendar-vue/dist/KalendarVue.css'

console.log(Kalendar)

export default {
  name: 'timeline',
  data () {
    return {
    users: {},
    card: {},
    service: {},
    serviceCategory: {},
    description: ''
    }
  },
firestore() {
  this.activePage  = this.$route.path.split('/card/')[1]

    return {
      users: firestore.collection('users'),
      card: firestore.collection('cards').doc(this.activePage),
      services: firestore.collection('services'),
      serviceCategory: firestore.collection('serviceCategory')
  }
},
components: {
  Kalendar
},
  watch: {

  },
  methods: {
    ...mapMutations([
      'logModules',
      'logIn',
      'logOut',
      'logInGoogle'
    ]),
    updateAppointment(payload){
      var confirm = prompt("Did patient confirm? Type 'yes' or 'no'", "yes");
      if (confirm === 'yes') {
        firestore.collection('cards').doc(payload.id).update({
          type: 'SA'
        })
      } else {
        alert('Appointment was not scheduled.')
      }
    },
    cancel(payload){
      firestore.collection('cards').doc(payload.id).update({
        type: 'AR'
      })
    },
    payBalance(payload){
      firestore.collection('cards').doc(payload.id).update({
        type: 'BP'
      })
    },
    messageUser(payload){
      return {
        message: this.messages.push(payload),
        push: this.$router.push('/messages/' + payload.uid)
      }
    },
    submitCard(payload){
      const createdAt = new Date()
      firestore.collection('cards').add({
        createdAt: createdAt,
        pid: this.user.uid,
        uid: payload.uid,
        type: 'SA',
        description: this.description
      })
      .then((data)=> {
        alert(data.id)
        // this.$router.push('/timeline')
      })
    }
  },
  computed: {
    getState() {
      return this.$store.state;
    },
    ...mapGetters([
      'loggedIn',
      'user',
      'isLoading',
      'messages',
      'activePatient'
    ]),
    // activePatient() {
    //   return this.$store.state.activePatient
    // },
    addEvent(popup_data, form_data) {
  let payload = {
    data: {
      title: this.new_appointment.title,
      description: this.new_appointment.description,
    },
    from: popup_info.start_time,
    to: popup_info.end_time,
  };

  this.$kalendar.addNewEvent(
    payload,
  );
  this.$kalendar.closePopups();
  this.clearFormData();
},

// Remove Event
removeEvent(kalendarEvent) {
  let day = kalendarEvent.start_time.slice(0, 10);
  this.$kalendar.removeEvent({
    day,
    key: kalendarEvent.key,
    id: kalendarEvent.kalendar_id,
  })
}
  }
}
</script>

<style lang="scss" scoped>

  $break-small: 900px;
  $brandColor: #29aad0;
  $brandColorTwo: #70c8df;
  $accentColor: #de7c5e;

.screen {
    // display: flex;
    // flex-direction: column;
    // flex-flow: wrap;
    padding: 0 0;
    width: 100%;
    // align-items: center;
    position: relative;
    font-family: "avenir", sans-serif;
    color: #fff;
    font-weight: bold;

    .edit-container {
      width: 20%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &__edit {
      width: 20px;
      height: 20px;
      background-color: #A45BEF;
      border-radius: 50%;
      border: 1px solid #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 10px;
      font-weight: bold;
      transform: scale(1);
      transition: all .3s ease-in-out;
      // &:hover {
      //   transform: scale(1.2);
      // }
    }

    .meta-overlay {
      background-color: rgba(0, 0, 0, 0.2);
    }
    .spacer-bottom {
      margin-bottom: 2em;
    }

    &__meta {
      width: 100%;
      height: auto;
      padding: 25px 0;
      border-top-right-radius: 30px;
      border-top-left-radius: 30px;
      margin: 0 auto;
      border-bottom: 1px solid #3E4051;
      text-align: left;
      display: flex;
      align-items: center;
      justify-content: center;

      .card-title {
        font-weight: 100;
        padding: 0 1em;
      }
      .description {
        width: 80%;
        margin: 0 auto;
        padding: 5px;
        font-weight: 100;
        background-color: transparent;
        color: #fff;
        outline: none;
        border: none;
        // display: flex;
        // align-items: center;
        // justify-content: center;

        &::placeholder {
          color: #fff;
          padding: 5px;

        }
      }
    }

    &__services {
      display: flex;
      flex-direction: row;
      padding: 20px 0;
      font-size: 10px;
      text-transform: uppercase;
      width: 90%;
      margin: 0 auto;
      letter-spacing: 1px;

      .service-tab {
        background-color: #eee;
        width: 80%;
        margin: 10px 0 0 0;
        padding: 10px;
        border-radius: 5px;
        color: #333;
      }
      .specific {
        width: 60%;
        text-align: left;
        justify-content: left;
        align-items: left;
        font-size: 14px;
      }
      .general {
        width: 40%;
        text-align: left;
        justify-content: left;
        align-items: left;
        font-size: 10px;
          .service-tab {
            width: 90%;
          }
      }
    }

    &__user {
      display: flex;
      flex-direction: column;
      width: 90%;
      margin: 0 auto;

      span {
        width: auto;
        text-align: left;
      }
      .number {
        color: #427ACA;
        font-weight: lighter;
      }

    }
    &__user-image {
    width: 70px;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border: 1px solid #574AFF;
    border-radius: 50%;
    margin: 0 0 10px 0;
      img {
        width: 35px;
      }

      &::after {
        content: "+";
        position: absolute;
        top: 0;
        right: 0;
        width: 15px;
        height: 15px;
        background-color: #A45BEF;
        border-radius: 50%;
        border: 1px solid #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 10px;
        font-weight: bold;
      }
  
    }

    .active-card {
      background-color: #00BC84;
    }
    &__card {
      position: relative;
      width: 90%;
      height: auto;
      // background-color: #00BC84;
      margin: 1em auto 2em auto;
      border-radius: 30px;
    }

    .schedule {
      background-color: #D7D4FF;
    }
    .progress {
      background-color: #00D194;
    }
    .treatment {
      background-color: #B5F5E6;
    }
    .messages {
      background-color: #FFEEBC;
    }
    .escripts {
      background-color: #D7D4FF;
    }
    .patient {
      background-color: #FFCFBF;
    }
    .insurance {
      background-color: #FFCFBF;
    }
    .office {
      background-color: #E8EDED;
    }
    &__actions {
      width: 100%;
      display: flex;
      flex-direction: column;
      text-transform: uppercase;
      align-items: center;
      justify-content: center;
      .submit {
        color: #FF0000;
        border: 1px solid #FF0000;
        width: 50%;
        margin: 1em auto 3em auto;
        padding: 5px 10px;
      }
      .message {
        color: rgb(255, 255, 255);
        border: 1px solid rgb(255, 255, 255);
        width: 50%;
        margin: 1em auto 3em auto;
        padding: 5px 10px;
      }
    }
    .tab {
        width: 24vw;
        height: 20vw;
        padding: 20px 30px;
        border-radius: 20px;
        margin: 1vw auto;
        display: flex;
        flex-direction: column;
        position: relative;
        align-items: left;
        justify-content: center;
        color: #333;
        cursor: pointer;
        background-color: #fff;

        @media screen and (max-width: $break-small) {
          width: 44vw;
          height: 42vw;
          margin: 3vw auto;
        }

        &:hover {
            // opacity: 0.9;
        }

        h2 {
          font-size: 1.5vw;
          text-align: left;
          text-transform: uppercase;
          font-family: "futura", sans-serif;
          font-weight: 500;
          letter-spacing: 1px;
          width: 100%;
          padding-left: 20px;
          @media screen and (max-width: $break-small) {
            font-size: 3vw;

          }
        }
 
        &__type {
            width: 15px;
            height: 15px;
            border-radius: 50%;
            position: absolute;
            top: calc(50% - 7.5px);
            left: 20px;
        }

            // sub settings of type
            .orange {
                background-color: $accentColor;
            }
            .yellow {
                background-color: #f8e85b;
            }
            .media {
                width: 30px;
                height: 30px;
                margin-left: -5px;
                img {
                    width: 20px;
                }
            }
            .grey {
                background-color: #ddd;
            }
        &__name {
            width: 70%;
            text-align: left;
            font-weight: 600;
            font-size: 16px;
        }
        &__description{
            width: 70%;
            text-align: left;
            font-weight: 300;
            font-size: 14px;
            font-style: italic;
            padding: 2px 0;
        }
    }
    
}

  
</style>



// WEBPACK FOOTER //
// src/components/Card.vue